import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Table, Button} from 'react-bootstrap';
import Moment from 'react-moment';
import SvgIcon from 'react-icons-kit';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';

var Config = require('../../../config');

class ModalDespatch extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.sendData = this.sendData.bind(this);

		this.state = {
			show: false,
			results:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(){

		this.props.waiting.handleShow("Cargando...");
		fetch(Config.default.apiGateway.URL+'unit_request?start_date='+
				'&end_date=&start_folio=&end_folio='+
				'&option=ENVIADO&health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
				'&type=requested_to&status=ENVIADO', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Conten-Type'	: 'application/json'
			})
		}).then(res => res.json())
		.then(response=>{
			this.props.waiting.handleClose();

			this.setState({
				results: response,
				show: true
			});
		});

	}

	handleClose(){
		this.setState({
			show: false
		});
	}

	sendData(id){
		this.handleClose();
		this.props.loadDespatch(id)
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize={"lg"} show={this.state.show} onHide={this.handleClose}>
				<Modal.Header closeButton>
		        	<Modal.Title>Listado despacho de unidades</Modal.Title>
		        </Modal.Header>
		        <Modal.Body>
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<Table responsive hover>
		        				<thead>
		        					<tr>
		        						<th>Solicitado por</th>
		        						<th>Componente</th>
		        						<th>Cantidad</th>
		        						<th>Estatus</th>
		        						<th>Fecha y Hora</th>
		        						<th></th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.results.map( (item, index) => (
					                    <tr key={item.unit_request.id}>
					                      	<td>{item.unit_request.id}</td>
											<td>{item.request_to.name}</td>
											<td>{item.components}</td>
											<td>{item.amount}</td>
											<td>{item.status}</td>
											<td><Moment format="DD/MM/YYYY">{item.unit_request.date}</Moment> - {item.unit_request.hour}</td>
											<td>
												<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
													onClick={this.sendData.bind(this, item.unit_request.id)}
													disabled={item.status !== 'ENVIADO'}>
													<SvgIcon icon={pencil2} />
												</Button>
											</td>
					                    </tr>
				                    ))}
		        				</tbody>
		        			</Table>
		        		</div>
		        	</div>
		        </Modal.Body>
			</Modal>
		)
	}

}

export default translate('translations')(ModalDespatch);